import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { api } from '../utils/api';
import { toast } from 'sonner';
import SEO from '../components/SEO';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.forgotPassword({ email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error('Något gick fel. Försök igen.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12" style={{ backgroundColor: '#F7F4EF' }} data-testid="forgot-password-page">
      <SEO title="Glömt lösenord | Operio" description="Återställ ditt Operio-lösenord via e-post" canonical="/glomt-losenord" noindex />
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-[#6B6560] hover:text-[#1A1A1A] mb-6">
          <ArrowLeft size={14} /> Till login
        </Link>
        <div className="bg-white rounded-2xl border border-[#E8E2D9] p-8 shadow-sm">
          {!sent ? (
            <>
              <div className="w-12 h-12 bg-[#E8613A]/10 rounded-xl flex items-center justify-center mb-5">
                <Mail size={22} className="text-[#E8613A]" />
              </div>
              <h1 className="text-2xl font-bold text-[#1A1A1A]" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
                Glömt ditt lösenord?
              </h1>
              <p className="text-sm text-[#6B6560] mt-2">
                Ange din e-postadress så skickar vi en återställningslänk.
              </p>
              <form onSubmit={onSubmit} className="mt-6 space-y-4">
                <div>
                  <Label className="text-xs">E-post</Label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="din@epost.se"
                    autoFocus
                    required
                    className="mt-1.5 h-11"
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button type="submit" disabled={loading} className="w-full bg-[#E8613A] hover:bg-[#D4532F] text-white h-11 rounded-full" data-testid="forgot-submit-btn">
                  {loading ? 'Skickar…' : 'Skicka återställningslänk'}
                </Button>
              </form>
            </>
          ) : (
            <div className="text-center" data-testid="forgot-success">
              <div className="w-14 h-14 mx-auto bg-green-100 rounded-full flex items-center justify-center">
                <CheckCircle2 size={28} className="text-green-600" />
              </div>
              <h1 className="text-2xl font-bold text-[#1A1A1A] mt-5" style={{ fontFamily: 'Cabinet Grotesk, sans-serif' }}>
                Kolla din inkorg
              </h1>
              <p className="text-sm text-[#6B6560] mt-2">
                Om <strong>{email}</strong> är registrerad har vi skickat en återställningslänk. Klicka i mailet inom 60 minuter.
              </p>
              <Link to="/login" className="inline-block mt-6 text-sm text-[#E8613A] hover:underline font-medium">
                Tillbaka till login
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
